var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"wrap"},[_c('img',{attrs:{"src":"https://cdn.kuaidi100.com/images/m/none.png?version=2"}}),_c('div',{staticClass:"text"},[_c('p',{staticClass:"big"},[_vm._v(" 404 ")]),_c('p',[_vm._v("您访问的页面不存在")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }